/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.tag.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.tag = {};
proto.witbooking.backoffice.tag.v1 = require('./tag_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.tag.v1.TagAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.tag.v1.TagAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.tag.v1.GetTagsRequest,
 *   !proto.witbooking.backoffice.tag.v1.GetTagsResponse>}
 */
const methodDescriptor_TagAPI_GetTags = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.tag.v1.TagAPI/GetTags',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.tag.v1.GetTagsRequest,
  proto.witbooking.backoffice.tag.v1.GetTagsResponse,
  /**
   * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.tag.v1.GetTagsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.tag.v1.GetTagsRequest,
 *   !proto.witbooking.backoffice.tag.v1.GetTagsResponse>}
 */
const methodInfo_TagAPI_GetTags = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.tag.v1.GetTagsResponse,
  /**
   * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.tag.v1.GetTagsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.tag.v1.GetTagsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.tag.v1.GetTagsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.tag.v1.TagAPIClient.prototype.getTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.tag.v1.TagAPI/GetTags',
      request,
      metadata || {},
      methodDescriptor_TagAPI_GetTags,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.tag.v1.GetTagsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.tag.v1.TagAPIPromiseClient.prototype.getTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.tag.v1.TagAPI/GetTags',
      request,
      metadata || {},
      methodDescriptor_TagAPI_GetTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest,
 *   !proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse>}
 */
const methodDescriptor_TagAPI_UpdateTagsAppliesTo = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.tag.v1.TagAPI/UpdateTagsAppliesTo',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest,
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse,
  /**
   * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest,
 *   !proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse>}
 */
const methodInfo_TagAPI_UpdateTagsAppliesTo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse,
  /**
   * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.tag.v1.TagAPIClient.prototype.updateTagsAppliesTo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.tag.v1.TagAPI/UpdateTagsAppliesTo',
      request,
      metadata || {},
      methodDescriptor_TagAPI_UpdateTagsAppliesTo,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.tag.v1.TagAPIPromiseClient.prototype.updateTagsAppliesTo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.tag.v1.TagAPI/UpdateTagsAppliesTo',
      request,
      metadata || {},
      methodDescriptor_TagAPI_UpdateTagsAppliesTo);
};


module.exports = proto.witbooking.backoffice.tag.v1;

